










// // src/pages/customers/module.js

// export const formHeading = "Customer";
// export const submitApi = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/customer/api/customers`;
// export const uriBasePath = "customers";
// export const newRecord = `/customers/new`;
// export const listApi = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/customer/api/customers`;

// // --- REMOVED THE API CALL FROM HERE ---

// export const formFields = [
//   {
//     fieldName: "name",
//     displayName: "Name",
//     sequence: 0,
//     required: true,
//     tag: "input",
//     inputType: "text",
//   },
//   {
//     fieldName: "address",
//     displayName: "Address",
//     sequence: 0,
//     required: true,
//     tag: "textarea",
//   },
//   {
//     fieldName: "city",
//     displayName: "City",
//     sequence: 1,
//     required: true,
//     tag: "input",
//     inputType: "text",
//   },
//   {
//     fieldName: "pincode",
//     displayName: "Pincode",
//     sequence: 1,
//     required: true,
//     tag: "input",
//     inputType: "text",
//     maxLength: "20",
//   },
//   {
//     fieldName: "state_id",
//     displayName: "State",
//     sequence: 2,
//     required: true,
//     tag: "select",
//     data: {
//       tableName: "state_master",
//       columnName: "state_name",
//     },
//   },
//   {
//     fieldName: "tally_name",
//     displayName: "Tally Name",
//     sequence: 2,
//     tag: "input",
//     inputType: "text",
//   },
//   {
//     fieldName: "parent_cust_id",
//     displayName: "Parent Customer",
//     sequence: 3,
//     tag: "select",
//     data: {
//       tableName: "customers",
//       columnName: "name",
//     },
//   },
//   {
//     fieldName: "vendor_code",
//     displayName: "Vendor Code",
//     sequence: 3,
//     tag: "input",
//     inputType: "text",
//   },
//   {
//     fieldName: "pan_no",
//     displayName: "PAN No.",
//     sequence: 4,
//     required: true,
//     tag: "input",
//     inputType: "text",
//     maxLength: "10",
//   },
//   {
//     fieldName: "gst_no",
//     displayName: "GST No.",
//     sequence: 4,
//     tag: "input",
//     inputType: "text",
//     maxLength: "15",
//   },
//   {
//     fieldName: "tin_no",
//     displayName: "TIN No.",
//     sequence: 5,
//     tag: "input",
//     inputType: "text",
//     maxLength: "15",
//   },
//   {
//     fieldName: "tan_no",
//     displayName: "TAN No.",
//     sequence: 5,
//     tag: "input",
//     inputType: "text",
//     maxLength: "10",
//   },
//   {
//     fieldName: "service_tax_no",
//     displayName: "Service Tax No.",
//     sequence: 6,
//     tag: "input",
//     inputType: "text",
//     maxLength: "20",
//   },
//   {
//     fieldName: "vendor_type",
//     displayName: "Vendor Type",
//     sequence: 6,
//     required: true,
//     tag: "select",
//     data: {
//       tableName: "common_master",
//       columnName: "vendor_type",
//       optionValueKey: "id",
//       optionLabelKey: "value",
//     },
//   },
//   {
//     fieldName: "contact_person",
//     displayName: "Contact Person",
//     sequence: 7,
//     required: true,
//     tag: "input",
//     inputType: "text",
//   },
//   {
//     fieldName: "email_id",
//     displayName: "Email ID",
//     sequence: 7,
//     required: true,
//     tag: "input",
//     inputType: "email",
//   },
//   {
//     fieldName: "contact_details",
//     displayName: "Contact Details",
//     sequence: 8,
//     required: true,
//     tag: "input",
//     inputType: "text",
//   },
//   {
//     fieldName: "active",
//     displayName: "Active",
//     sequence: 8,
//     tag: "input",
//     inputType: "checkbox",
//   },
// ];

// export const tableFields = [
//   { fieldName: "id", displayName: "ID" },
//   { fieldName: "name", displayName: "Name" },
//   { fieldName: "address", displayName: "Address" },
//   { fieldName: "city", displayName: "City" },
//   { fieldName: "pincode", displayName: "Pincode" },
//   { fieldName: "state_id", displayName: "State" },
//   { fieldName: "tally_name", displayName: "Tally Name" },
//   { fieldName: "parent_cust_id", displayName: "Parent Customer" },
//   { fieldName: "vendor_code", displayName: "Vendor Code" },
//   { fieldName: "pan_no", displayName: "PAN No." },
//   { fieldName: "gst_no", displayName: "GST No." },
//   { fieldName: "tin_no", displayName: "TIN No." },
//   { fieldName: "tan_no", displayName: "TAN No." },
//   { fieldName: "service_tax_no", displayName: "Service Tax No." },
//   { fieldName: "vendor_type", displayName: "Vendor Type" },
//   { fieldName: "contact_person", displayName: "Contact Person" },
//   { fieldName: "email_id", displayName: "Email ID" },
//   { fieldName: "contact_details", displayName: "Contact Details" },
//   {
//     fieldName: "active",
//     displayName: "Active",
//     render: (value) => (value ? "Yes" : "No"),
//   },
//   // The render logic is now handled dynamically in the CustomerList component
//   {
//     fieldName: "added_by",
//     displayName: "Added By",
//   },
//   {
//     fieldName: "add_date",
//     displayName: "Add Date",
//     render: (value) => (value ? new Date(value).toLocaleString() : "N/A"),
//   },
//   // The render logic is now handled dynamically in the CustomerList component
//   {
//     fieldName: "updated_by",
//     displayName: "Updated By",
//   },
//   {
//     fieldName: "update_date",
//     displayName: "Update Date",
//     render: (value) => (value ? new Date(value).toLocaleString() : "N/A"),
//   },
// ];

// export const validationRules = [];
// export const calculationRules = [];





// // src/pages/customers/module.js









// src/pages/customers/module.js

export const formHeading = "Customer";
export const submitApi = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/customer/api/customers`;
export const uriBasePath = "customers";
export const newRecord = `/customers/new`;
export const listApi = `${process.env.REACT_APP_NODE_SERVICE_BASE_URL}/customer/api/customers`;

// --- REMOVED THE API CALL FROM HERE ---

export const formFields = [
  {
    fieldName: "name",
    displayName: "Name",
    sequence: 0,
    required: true,
    tag: "input",
    inputType: "text",
  },
  {
    fieldName: "address",
    displayName: "Address",
    sequence: 0,
    required: true,
    tag: "textarea",
  },
  {
    fieldName: "city",
    displayName: "City",
    sequence: 1,
    required: true,
    tag: "input",
    inputType: "text",
  },
  {
    fieldName: "pincode",
    displayName: "Pincode",
    sequence: 1,
    required: true,
    tag: "input",
    inputType: "text",
    maxLength: "20",
  },
  {
    fieldName: "state_id",
    displayName: "State",
    sequence: 2,
    required: true,
    tag: "select",
    data: {
      tableName: "state_master",
      columnName: "state_name",
    },
  },
  {
    fieldName: "tally_name",
    displayName: "Tally Name",
    sequence: 2,
    tag: "input",
    inputType: "text",
  },
  {
    fieldName: "parent_cust_id",
    displayName: "Parent Customer",
    sequence: 3,
    tag: "select",
    data: {
      tableName: "customers",
      columnName: "name",
    },
  },
  {
    fieldName: "vendor_code",
    displayName: "Vendor Code",
    sequence: 3,
    tag: "input",
    inputType: "text",
  },
  {
    fieldName: "pan_no",
    displayName: "PAN No.",
    sequence: 4,
    required: true,
    tag: "input",
    inputType: "text",
    maxLength: "10",
  },
  {
    fieldName: "gst_no",
    displayName: "GST No.",
    sequence: 4,
    tag: "input",
    inputType: "text",
    maxLength: "15",
  },
  {
    fieldName: "tin_no",
    displayName: "TIN No.",
    sequence: 5,
    tag: "input",
    inputType: "text",
    maxLength: "15",
  },
  {
    fieldName: "tan_no",
    displayName: "TAN No.",
    sequence: 5,
    tag: "input",
    inputType: "text",
    maxLength: "10",
  },
  {
    fieldName: "service_tax_no",
    displayName: "Service Tax No.",
    sequence: 6,
    tag: "input",
    inputType: "text",
    maxLength: "20",
  },
  {
    fieldName: "vendor_type",
    displayName: "Vendor Type",
    sequence: 6,
    required: true,
    tag: "select",
    data: {
      tableName: "common_master",
      columnName: "vendor_type",
      optionValueKey: "id",
      optionLabelKey: "value",
    },
  },
  {
    fieldName: "contact_person",
    displayName: "Contact Person",
    sequence: 7,
    required: true,
    tag: "input",
    inputType: "text",
  },
  {
    fieldName: "email_id",
    displayName: "Email ID",
    sequence: 7,
    required: true,
    tag: "input",
    inputType: "email",
  },
  {
    fieldName: "contact_details",
    displayName: "Contact Details",
    sequence: 8,
    required: true,
    tag: "input",
    inputType: "text",
  },
  {
    fieldName: "active",
    displayName: "Active",
    sequence: 8,
    tag: "input",
    inputType: "checkbox",
  },
];

export const tableFields = [
  { fieldName: "id", displayName: "ID" },
  { fieldName: "name", displayName: "Name" },
  { fieldName: "address", displayName: "Address" },
  { fieldName: "city", displayName: "City" },
  { fieldName: "pincode", displayName: "Pincode" },
  { fieldName: "state_id", displayName: "State" },
  { fieldName: "tally_name", displayName: "Tally Name" },
  { fieldName: "parent_cust_id", displayName: "Parent Customer" },
  { fieldName: "vendor_code", displayName: "Vendor Code" },
  { fieldName: "pan_no", displayName: "PAN No." },
  { fieldName: "gst_no", displayName: "GST No." },
  { fieldName: "tin_no", displayName: "TIN No." },
  { fieldName: "tan_no", displayName: "TAN No." },
  { fieldName: "service_tax_no", displayName: "Service Tax No." },
  { fieldName: "vendor_type", displayName: "Vendor Type" },
  { fieldName: "contact_person", displayName: "Contact Person" },
  { fieldName: "email_id", displayName: "Email ID" },
  { fieldName: "contact_details", displayName: "Contact Details" },
  {
    fieldName: "active",
    displayName: "Active",
    render: (value) => (value ? "Yes" : "No"),
  },
  // The render logic is now handled dynamically in the CustomerList component
  {
    fieldName: "added_by",
    displayName: "Added By",
  },
  {
    fieldName: "add_date",
    displayName: "Add Date",
    render: (value) => (value ? new Date(value).toLocaleString() : "N/A"),
  },
  // The render logic is now handled dynamically in the CustomerList component
  {
    fieldName: "updated_by",
    displayName: "Updated By",
  },
  {
    fieldName: "update_date",
    displayName: "Update Date",
    render: (value) => (value ? new Date(value).toLocaleString() : "N/A"),
  },
];

export const validationRules = [];
export const calculationRules = [];


